import React, { useMemo } from 'react';
import { PwcLoader } from '@pwc/pwc-deals-ui';
import { useDispatch, useSelector } from 'react-redux';
import { getIsDarkModeSelector } from '../../redux/userSettings/userSettingsSlice';
import {
  getGlobalErrorState,
  hideGlobalError,
} from '../../redux/errors/errorsSlice';
import { ErrorMessages } from './constants';

const getErrorMessage = (errorCode, paramsToMatch) => {
  const message = ErrorMessages[errorCode];
  if (message) {
    const regExp = Object.keys(paramsToMatch).join('|');
    return message.replace(regExp, (matched) => {
      return paramsToMatch[matched] || '';
    });
  }
  return '';
};

const GlobalError = () => {
  const dispatch = useDispatch();
  const darkMode = useSelector(getIsDarkModeSelector);
  const themeName = useMemo(() => {
    if (darkMode === undefined) return 'default';
    return darkMode ? 'default' : 'light';
  }, [darkMode]);

  const errorState = useSelector(getGlobalErrorState);
  const {
    id,
    eventType,
    classes = 'global-error-container',
    confirm,
    cancel,
    close,
    metadata,
    userName,
  } = errorState;
  if (errorState.error) {
    const { code } = errorState.error;
    const message = getErrorMessage(code, { '{userName}': userName });
    const error = {
      ...errorState.error,
      message,
    };

    const handleModalClose = () => {
      dispatch(hideGlobalError());
    };

    return (
      <PwcLoader
        errorConfig={{
          type: eventType,
          id,
          themeName,
          error,
          props: {
            ...metadata,
            classes,
            confirm: () => {
              handleModalClose();
              if (confirm) {
                confirm();
              }
            },
            cancel: () => {
              handleModalClose();
              if (confirm) {
                cancel();
              }
            },
            close: () => {
              handleModalClose();
              if (confirm) {
                close();
              }
            },
          },
        }}
      />
    );
  }
  return <></>;
};

export default GlobalError;
